import { TranslateService } from '@ngx-translate/core';

export const STRAKIT_TRANSLATIONS_DICT = {
  'label.Clear': 'Clear',
  'label.ClearAll': 'Clear All',
  'label.TypeToSearch': 'Type to search',
  'label.Close': 'Close',
  'label.Cancel': 'Cancel',
  'label.Select': 'Select',
  'label.ListIsEmpty': 'List is empty',
  'label.CustomValue': 'Custom value',
  'label.KVValue': 'KV Value',
  'label.Translation': 'Translation',
  'label.Save': 'Save',
  'label.Source': 'Source',
  'label.Translate': 'Translate',
  'label.Translations': 'Translations',
  'label.TimeZone': 'Time Zone',
  'label.Back': 'Back',
  'label.Today': 'Today',
  'label.Apply': 'Apply',
  'label.Absolute': 'Absolute',
  'label.Relative': 'Relative',
  'label.PlaceholderType': 'Type',
  'label.PlaceholderPart': 'Part',
  'label.Now': 'Now',
  'label.Add': 'Add',
  'label.StartOf': 'Start of',
  'label.EndOf': 'End of',
  'label.Hour': 'Hour',
  'label.Day': 'Day',
  'label.Week': 'Week',
  'label.Month': 'Month',
  'label.Year': 'Year',
  'message.DeleteItemConfirm': 'Are you sure you want to delete this item?',
  'label.ConfirmationText': 'Confirmation text',
  'label.CriticalConfirmTitle': 'This action can lead to irreversible results',
  'label.ConfirmTitle': 'This action needs your confirmation',
  'label.Message': 'Message',
  'label.Yes': 'Yes',
  'label.TotalItems': 'Total Items',
  'label.Selected' : 'Selected',
  'label.of': 'Of',
  'label.Page': 'Page',
  'label.PageSize': 'Page size',
  'label.Collapse': 'Collapse',
  'label.Expand': 'Expand',
  'label.Copy': 'Copy',
  'label.Copied': 'Copied',
};

export function translateStrakitDict(translateService: TranslateService): void {

  for (const key of Object.keys(STRAKIT_TRANSLATIONS_DICT)) {
    STRAKIT_TRANSLATIONS_DICT[key] = translateService.instant(key);
  }
}
